import { ALL_TAB_KEY } from "./pageTabs";

export function getWorkspaceDataSection(
  dataPageNameField?: string,
  pinnedFilters?: Record<string, string[]>,
) {
  const rawPageName = dataPageNameField
    ? pinnedFilters?.[dataPageNameField]?.[0]
    : undefined;

  return rawPageName === ALL_TAB_KEY ? `page:${ALL_TAB_KEY}` : rawPageName;
}
